import { TextareaAutosizeProps } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { StyledTextarea } from './styles';

const Textarea: FunctionComponent<TextareaAutosizeProps> = (props) => <StyledTextarea {...props} />;

export default Textarea;
